var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Carousel'),_c('MainPage',{on:{"clickNew":_vm.scrollToBenefit}}),_c('Benefit',{ref:"refBenefit",attrs:{"id":"benefit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }